<template>
  <div>
    <el-card class="wrap-menu"
      shadow="never"
      v-loading="loading"
    >
      <div slot="header">
        <div class="text">类型选择</div>
        <el-form @submit.native.prevent>
          <el-form-item>
            <el-input
              class="typeNameInput"
              v-model="typeName"
              placeholder="服务类型名称"
              clearable>
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="getTableData">
              </el-button>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="channel-sel">
        <el-menu
          default-active=""
          @select="itemSelect">
          <el-menu-item index="">
            <span slot="title">全部</span>
          </el-menu-item>
          <el-menu-item
            :index="entity.serviceTypeId"
            v-for="entity in itemData"
            :key="entity.serviceTypeId">
            <span slot="title">{{entity.name}}</span>
          </el-menu-item>
        </el-menu>
      </div>
    </el-card>
  </div>
</template>

<script>
import {serve} from '../../api'
import {getSession} from '../../utils/session'
import {ORG_CODE} from '../../constants'
export default {
  name: 'ServeItem',
  data () {
    return {
      typeName: '',
      itemData: [],
      loading: false
    }
  },
  created () {
    this.getTableData()
  },
  methods: {
    itemSelect (val) {
      this.$emit('service-type-id', val)
    },
    async getTableData () {
      this.loading = true
      let {data} = await serve.listServeType({param: {onFlag: true, name: this.typeName, orgCode: getSession(ORG_CODE)}})
      this.loading = false
      this.itemData = data
    }
  }
}
</script>

<style lang="scss" scoped>
  .radio-text {
    color: $disabled;
  }
  .channel-sel {
    height: calc(100vh - 300px);
    overflow: auto !important;
  }

  .text {
    margin-left: 10px;
  }

  .wrap-menu {
    width: 220px;
    height: calc(100vh - 150px);
    flex-shrink: 0;
    box-sizing: border-box;
    .typeNameInput {
      width: 200px;
      margin-top: 10px;
    }
    /deep/ .el-card__header {
      padding: 10px 10px 0 10px;
    }
    /deep/ .el-menu {
      border: none;
      .el-menu-item {
        height: 30px;
        line-height: 30px;
      }
    }
  }

  .el-form-item {
    margin-bottom: 10px;
  }
</style>
